// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--XPWhB","title-wrapper":"_9e1425b4d3--title-wrapper--VTNre","rubric":"_9e1425b4d3--rubric--VJtsi","title":"_9e1425b4d3--title--uGms8"};